import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container } from 'reactstrap';
import Swal from 'sweetalert2';

import { getRoles, addRoles, updateRoles, deleteRoles } from '../../../store/Roles/actions';

import Breadcrumbs from '../../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import FormRoles from './form-roles';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import usePageTitle from '../../../common/hooks/usePageTitle';

const RolesList = (props: any) => {
    const dispatch = useDispatch();
    const { roles, CountItems } = useSelector((state: any) => state.Roles);

    const PageTitleRoles = usePageTitle(props.location.pathname);

    const [tableViewList] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const valuesSizePagination = [10, 20, 30, 40, 50, 100];
    const [pagination, setPagination] = useState<any>({
        sizePerPage: valuesSizePagination[0],
        page: 1,
    });

    const[ order, setOrder ]= useState( "{'id': 'ASC'}" )

    const textName = 'Search Name';

    const [queryString, setQueryString] = useState<any>({});
    const [listDataState, setListDataState] = useState([]);

    useEffect(() => {
        dispatch(getRoles({ pagination, data: {...queryString, order} }));
    }, [dispatch, pagination]);

    useEffect(() => {
        dispatch(getRoles({ pagination, data: {...queryString, order} }));
    }, []);

    useEffect(() => {
        setListDataState(roles);
    }, [roles, pagination]);

    useEffect(() => {
        let userConsultName = false;

        const queryTextName = queryString[textName];

        if (queryTextName !== undefined ? (queryTextName.length > 3 && queryTextName.length > 0) || queryTextName === '' : true) {
            userConsultName = true;
        }

        if (userConsultName) {
            queryString ?? setListDataState([]);
            dispatch(getRoles({ pagination, data: {...queryString, order} }));
        }
    }, [pagination, queryString, order]);

    const initialArrayTable = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, roles: any) => <>{roles.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'nombre',
            formatter: (cellContent: any, roles: any) => <>{roles.nombre}</>,
            hidden: false,
        },
        {
            text: 'Version',
            dataField: 'version',
            formatter: (cellContent: any, roles: any) => <>{roles.version}</>,
            hidden: false,
        },
        {
            text: 'Description',
            dataField: 'descripcion',
            formatter: (cellContent: any, roles: any) => <>{roles.descripcion}</>,
            hidden: false,
        },
        {
            text: 'MCA_ACTIVO',
            dataField: 'MCA_ACTIVO',
            formatter: (cellContent: any, roles: any) => {
                return (
                    <ISwitch
                        checked={roles.MCA_ACTIVO}
                        onChangeBooleanHandler={(args:any) => {
                            const newObject = { ...roles };
                            newObject.MCA_ACTIVO = args;
                            dispatch(updateRoles({ role: newObject, pagination, data: {...queryString, order} }));
                        }}
                    />
                );
            },
            hidden: false,
        },
        {
            text: 'MCA_SUPERUSUARIO',
            dataField: 'MCA_SUPERUSUARIO',
            formatter: (cellContent: any, roles: any) => {
                return (
                    <ISwitch
                        checked={roles.MCA_SUPERUSUARIO}
                        onChangeBooleanHandler={(args:any) => {
                            const newObject = { ...roles };
                            newObject.MCA_SUPERUSUARIO = args;
                            dispatch(updateRoles({ role: newObject, pagination, data: {...queryString, order} }));
                        }}
                    />
                );
            },
            hidden: false,
        },
    ];

    const handleCreateRoles = (role: any) => {
        setpopUpState(!popUpState);
        dispatch(addRoles({ role, pagination, data: {...queryString, order} }));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
    };

    const handleUpdateRoles = (role: any) => {
        setpopUpState(!popUpState);
        dispatch(updateRoles({ role, pagination, data: {...queryString, order} }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
    };

    const handleDeleteRoles = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(deleteRoles({ id, pagination, data: {...queryString, order} }) );
        Swal.fire({
            icon: 'success',
            title: 'Deleted!!!',
            text: 'Items have been deleted successfully!!!',
        });
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };
    const handleCancel = () => {
        setpopUpState(!popUpState);
    };
    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type :any, { sortField, sortOrder }:any) => {
        setOrder( `{'${sortField}' : '${sortOrder.toUpperCase()}'}` )
    }
    /* Filters */

    const onChangeHandler = (e: any, n: any) => {
        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const AdminFilters = () => {
        return (
            <div className="col-6">
                <div className="justify-content-center">
                    <IInput title={textName} type={'text'} value={queryString[textName]} onChangeHandler={onChangeHandler} />
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div id="main" style={{ overflow: 'auto' }}>
                {/* <div id="menuColumn"></div> */}
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>{PageTitleRoles.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid>
                        <div>
                            <div className="row justify-content-center me-2">
                                <div className="d-flex justify-content-end pb-3">
                                    <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                        + Add
                                    </button>
                                </div>
                                {AdminFilters()}
                            </div>
                        </div>

                        <Col lg="12">
                            <ITable
                                valuesSizePagination={valuesSizePagination}
                                CountItems={CountItems}
                                remote={true}
                                data={listDataState}
                                fields={initialArrayTable}
                                tableColumns={initialArrayTable}
                                pagSize={4}
                                pageStartIn={0}
                                showTotal={true}
                                disablePageTitle={true}
                                headerColorT={'bg-primary text-white'}
                                tableViewList={tableViewList}
                                groupName=""
                                handlePopUpState={onPopUpState}
                                actionOnRowClick={handleActionOnRowClick}
                                handlerPaginationState={handlePaginationChange}
                                handleTableSort={handleTableSort}
                            />
                        </Col>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={'Roles'}
                modaleTitleUpdate={'Update Roles'}
                icon="users"
                colorHeaderPop={'#101340'}
            >
                <FormRoles
                    selectedRow={selectedRow}
                    onCreateRoles={handleCreateRoles}
                    onUpdateRoles={handleUpdateRoles}
                    onDeleteRoles={handleDeleteRoles}
                    onCancel={handleCancel}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default RolesList;
